import React from 'react'
import clsx from 'clsx'

export default function Body({ children, className, ...rest }) {
  return (
    <div className={clsx(className || 'px-6 py-4')} {...rest}>
      {children}
    </div>
  )
}
